module.exports = __webpack_public_path__ + "img/2-7-stratosphere.b6b95d4d.jpg";